import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { gaceta_item } from "../../../json/gaceta";
import "./stylessh.css";

const Gaceta = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Gaceta Hidalguense de Investigación en Salud</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
        {gaceta_item.map((item, index) => (
          <div key={index}>
            <h5><b><b>{item.gaceta_item_titulo_imagen}</b></b></h5>
            <a href={item.gaceta_item_url} target={"_blank"}><img className="img-gaceta" src={item.gaceta_item_imagen}  /></a>
            <h4 className="titulo-bloque">Contenido</h4>
            <hr className="tramitehr" />
            <ul className="list-mark">
              {item.gaceta_item_list.map((listItem, listItemIndex) => (
                <li key={listItemIndex}>{listItem}</li> 
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gaceta;